import { Tab, Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledTabs = styled(Tabs)(({ theme }) => ({}));

export const StyledTab = styled(Tab)(({ theme }) => ({
  fontFamily: 'Readex Pro',
}));

export const StyledTableWrapper = styled('div')(({ theme }) => ({
  // height: isExpanded ? '755px' : '0px',
  overflow: 'hidden',
  transition: 'height 0.3s ease-in-out',
  borderRadius: theme.spacing(1),
  '& .MuiPaper-root>div': {
    padding: theme.spacing(1),
  },
  '& td,& th': {
    padding: 0,
    paddingRight: theme.spacing(1),
    height: '24px',
    borderBottomWidth: 0,
  },
  '& td:last-child,& th:last-child': {
    paddingRight: 0,
  },
  '& .MuiTableCell-root': {
    borderBottom: 'none',
  },
}));
